import type { AskBackOption } from "../../contract"
import { blockKey, useAnswerSession } from "../session"
import { useBlockScope } from "./context"

/** The decisive-fact question. A choice shows its sentence and rewrites the section takeaway locally. */
export function AskBack({ question, options, path }: { question: string; options: AskBackOption[]; path: string }) {
  const { turn, section } = useBlockScope()
  const k = blockKey(turn, section, path)
  const value = useAnswerSession((s) => s.choices[k] ?? "")
  const choose = useAnswerSession((s) => s.choose)
  const picked = options.find((o) => o.value === value)
  return (
    <div className="ask">
      <p className="q">{question}</p>
      <div className="pills" role="group" aria-label={question}>
        {options.map((o) => (
          <button key={o.value} type="button" className="pill" aria-pressed={o.value === value} onClick={() => choose(k, o.value)}>
            {o.label}
          </button>
        ))}
      </div>
      <p className="pr aout" aria-live="polite">
        {picked ? (
          <>
            {picked.sentence}{" "}
            <button type="button" className="tl" onClick={() => choose(k, "")}>Change</button>
          </>
        ) : null}
      </p>
    </div>
  )
}
